import { print } from "graphql";
import { Client } from "graphql-ws";
import { setState } from "~/store";
import {
	SubscribeToSystemHealthDocument,
	SubscribeToSystemHealthSubscription,
} from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		subscription SubscribeToSystemHealth {
			subscribeToSystemHealth {
				type
			}
		}
	`
);

export const subscribeToSystemHealth = (client: Client) =>
	client.subscribe<SubscribeToSystemHealthSubscription>(
		{ query: print(SubscribeToSystemHealthDocument) },
		{
			next: (result) => {
				if (result.data) {
					const { type } = result.data.subscribeToSystemHealth;
					switch (type) {
						case "init": {
							setState({ isConnectedToServer: true });
							break;
						}
						case "shutdown": {
							setState({ isConnectedToServer: false });
							break;
						}
					}
				}
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
